import { createSlice } from "@reduxjs/toolkit";

// Load persisted admin state from localStorage
const loadPersistedAdminState = () => {
  try {
    const persistedState = localStorage.getItem('adminState');
    if (persistedState) {
      const parsed = JSON.parse(persistedState);
      if (parsed.token && parsed.user && parsed.isLoggedIn) {
        return parsed;
      }
    }
  } catch (error) {
    console.error('Error loading persisted admin state:', error);
  }
  return { user: null, isLoggedIn: false, token: null };
};

const initialState = {
  user: null,
  isLoggedIn: false,
  token: null,
  admin: loadPersistedAdminState(),
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isLoggedIn = true;
    },
    loginAdmin: (state, action) => {
      const { user, token } = action.payload;
      
      // Ensure admin object exists
      if (!state.admin) {
        state.admin = { user: null, token: null, isLoggedIn: false };
      }
      
      state.admin.user = user;
      state.admin.token = token;
      state.admin.isLoggedIn = true;
      
      // Persist admin state to localStorage
      try {
        localStorage.setItem('adminState', JSON.stringify({
          user,
          token,
          isLoggedIn: true
        }));
      } catch (error) {
        console.error('Error persisting admin state:', error);
      }
    },
    update: (state, action) => {
      state.user = action.payload;
    },
    updateAdmin: (state, action) => {
      // Ensure admin object exists
      if (!state.admin) {
        state.admin = { user: null, token: null, isLoggedIn: false };
      }
      
      state.admin.user = action.payload;
      
      // Update localStorage as well
      try {
        const currentAdminState = JSON.parse(localStorage.getItem('adminState') || '{}');
        localStorage.setItem('adminState', JSON.stringify({
          ...currentAdminState,
          user: action.payload
        }));
      } catch (error) {
        console.error('Error updating admin state:', error);
      }
    },
    logout: (state, action) => {
      const scope = action?.payload?.scope || "all";
      if (scope === "admin") {
        state.admin = { user: null, token: null, isLoggedIn: false };
        try {
          localStorage.removeItem('adminState');
        } catch (error) {
          console.error('Error clearing admin state:', error);
        }
      } else if (scope === "customer") {
        state.user = null;
        state.token = null;
        state.isLoggedIn = false;
      } else {
        state.user = null;
        state.token = null;
        state.isLoggedIn = false;
        state.admin = { user: null, token: null, isLoggedIn: false };
        try {
          localStorage.removeItem('adminState');
        } catch (error) {
          console.error('Error clearing admin state:', error);
        }
      }
    },
  },
});

export const { login, loginAdmin, update, updateAdmin, logout } = userSlice.actions;
export default userSlice.reducer;